document.addEventListener('DOMContentLoaded', ()=>{
  var RelatedModuleSwiperMb = new Swiper(".Mb__swiperRelatedModule.swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }    
  })    
})